
import { Options, prop, Vue } from "vue-class-component";

class Props {
  modelValue = prop<boolean>({
    default: false,
    type: Boolean,
    required: true
  });
}

@Options({
  emits: ["update:modelValue", "see-all"]
})
class ClientDiscountConfigToggle extends Vue.with(Props) {
  get isDiscount() {
    return this.modelValue;
  }

  set isDiscount(value) {
    this.$emit("update:modelValue", value);
  }
}

export default ClientDiscountConfigToggle;
